import React from "react";
import AddTalks from "../../Administrative/AddTalks";

const AddYuvasarthiTalks = () => {
  return (
    <div>
      <AddTalks role="Super Admin" />
    </div>
  );
};

export default AddYuvasarthiTalks;
